module.exports = __webpack_public_path__ + "static/media/topMover.2f3302aa.png";